<template>
  <header class="position-sticky border-bottom bg-dark">
    <div class="container h-100">
      <div class="row align-items-center h-100">
        <div class="col-12">
          <div class="logo-container">
            <a href="/" class="h1 text-white">Linnea Kwarnmark</a>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
  export default {
    name: "site-header",
    data() {
      return {
        events: []
      }
    },
    async mounted() {
    }
  }
</script>

<style lang="scss" scoped>
  // header { height: 61px; }
  header { height: 80px; top: 0; z-index: 1; background-color: #FFF; }

  .logo-container {
    img {
      width: 181px;
      height: 74px;
    }
  }

  .header-border {
    height: 58px;
  }

  .header-link {
    color: #FFF;

    &:hover {
      text-decoration: underline;
    }
  }
</style>